import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ContactRequest } from './ContactRequest';
import { ContactResponse } from './ContactResponse';
import { environment } from 'src/environments/environment';
import { map, catchError } from "rxjs/operators";
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private httpClient:HttpClient) { }

  enviarContacto(contactRequest:ContactRequest){
    // console.log("go1");
    let url = `${environment.urlBase}${environment.contacto}?`;
    return this.httpClient.post<ContactResponse>(url, contactRequest).pipe(
      map(data => {
        let response: ContactResponse;
        response = data;
        return response;
      }),
      catchError(error => {
        // console.log("go2",error);
        return of(new ContactResponse("9999", "Error al enviar correo"));
      })
    );
  }

}
